import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue as firebaseOnValue } from "firebase/database";
import { onMessage, getMessaging, getToken as getMessagingToken } from "firebase/messaging";
import { getRedirectUrl } from "./NotificationNavigation";

const firebaseConfig = {
    apiKey: "AIzaSyB8d6OHUCQhzKNgI6TTCXygdEYxfxj8tOk",
    authDomain: "tappetbox-iam.firebaseapp.com",
    databaseURL: "https://tappetbox-iam-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "tappetbox-iam",
    storageBucket: "tappetbox-iam.appspot.com",
    messagingSenderId: "583441746645",
    appId: "1:583441746645:web:8c5570c2567f929de0f05c",
    measurementId: "G-87KPED2SEG"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export const getFireBaseConfig =  firebaseConfig;

export const systemRef = ref(database, 'system');

export const messaging = getMessaging(app);

export const getToken = getMessagingToken;

export const onValue = firebaseOnValue;
 

let origon_url = window.location.origin;


/***************
 * Service Worker: public/firebase-messaging-sw.js
 * Note: This file is separate and should be placed in the public/ directory of your React app.
 * It handles background messages and notification clicks when the app is not in the foreground.
 * The code below is for reference and should be copied to public/firebase-messaging-sw.js
 * Handle foreground messagese.g., when the user is actively using the app
 ***************/
onMessage(messaging, (payload) => {

    console.log("Foreground message:", payload);
    const notification      =   (payload && payload.notification) || {};
    const data              =   (payload && payload.data) || {};
    const title             =   notification.title || data.title || 'New notification';
    const body              =   notification.body || data.body || '';
    const iconUrl           =   notification.icon || data.icon || '/tap-favicon-black.png';

    // 👇 Show notification even when browser is open
    if (Notification.permission === "granted") {

        const notification =  new Notification(title, {
            body            :   body,
            icon            :   iconUrl,
            badge           :   '/logo192.png',
            data: {
                ...data
            }
        });

        notification.onclick = (event) => {
            event.preventDefault();
            let data      =   event.target.data || {};


            let targetUrl = getRedirectUrl(data, true);

 
            window.focus();
            window.location.href = targetUrl; // full reload but reliable
        };
    }
});


 